module.exports = __webpack_public_path__ + "17a6bada20e36b92b3f97a5152f2422c.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/ranking-widget.png
// module id = 2412
// module chunks = 0